import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../styles/products.css";

import ppe from "../images/products/ppe.webp";
import fasteners from "../images/products/fasteners.webp";
import tools from "../images/products/tools.webp";
import painting from "../images/products/painting.webp";
import abrasives from "../images/products/abrasives.webp";
import oilfield from "../images/products/oil-fitting.webp";
import packing from "../images/products/packing-material.jpg";

const products = [
  {
    name: "PPE",
    subtitle: "Personal Protective Equipment",
    icon: "fa-shield",
    image: ppe
  },
  {
    name: "Fasteners",
    subtitle: "Bolts, Nuts & Hardware",
    icon: "fa-cogs",
    image: fasteners
  },
  {
    name: "Industrial Tools",
    subtitle: "Heavy-duty Tools & Equipment",
    icon: "fa-wrench",
    image: tools
  },
  {
    name: "Painting Accessories",
    subtitle: "Brushes, Rollers & Supplies",
    icon: "fa-paint-brush",
    image: painting
  },
  {
    name: "Abrasives",
    subtitle: "Grinding & Polishing Solutions",
    icon: "fa-circle-o-notch",
    image: abrasives
  },
  {
    name: "Oil Field Fittings",
    subtitle: "High-pressure Industrial Fittings",
    icon: "fa-industry",
    image: oilfield
  },
  {
    name: "Packing Materials",
    subtitle: "Industrial Packaging Solutions",
    icon: "fa-dropbox",
    image: packing
  }
];

function ProductsPreview() {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    cardsRef.current.forEach(card => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="products">
      <div className="container">

        <span className="section-tag">Our Products</span>
        <h2 className="section-title">
          Comprehensive Range of <span>Industrial Supplies</span>
        </h2>

        <div className="product-grid">
          {products.map((item, index) => (
            <Link
              to="/products"
              key={index}
              className="product-card"
              ref={el => (cardsRef.current[index] = el)}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              <div
                className="product-image"
                style={{ backgroundImage: `url(${item.image})` }}
              ></div>

              <div className="product-content">
                <div className="product-icon">
                  <i className={`fa ${item.icon}`}></i>
                </div>

                <h3>{item.name}</h3>
                <p>{item.subtitle}</p>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}

export default ProductsPreview;
